const getEntities = state => state.entityTypes;

export default {
  getEntities
};